import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { Router } from '@angular/router';
import { RoutesPath } from '../../../../../shared/constants/routes-path';

@Component({
  selector: 'app-preview-application',
  imports: [CommonModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './preview-application.component.html',
  styleUrl: './preview-application.component.scss'
})
export class PreviewApplicationComponent {
  formProgress: number = 90;
  data: any = "";
  products: any[] = [
    {
      desc: 'Cocoa beans, whole or broken, raw or roasted',
      hsCode: '18010000',
      unit: 'KG',
      qty: 1000,
      unitPrice: 2500,
      weight: 1000,
      origin: 'United Arab Emirates'
    },
    {
      desc: 'Cocoa beans, whole or broken, raw or roasted',
      hsCode: '18010000',
      unit: 'KG',
      qty: 1000,
      unitPrice: 2500,
      weight: 1000,
      origin: 'United Arab Emirates'
    }
  ];
  journeyList: any[] = [
    {
      title: 'ATA_CARNET.DESTINATION',
      value: "1",
      fields: [
        { label: 'ATA_CARNET.DEST_COUNTRY', value: 'India' },
        { label: 'ATA_CARNET.ENTRY_TYPE', value: 'Transit' },
        { label: 'ATA_CARNET.MODE_OF_TRANSPORT', value: 'By Air' },
        { label: 'ATA_CARNET.COUNTERFOLLIOS_REQUIRED', value: 2 }
      ]
    },
    {
      title: 'ATA_CARNET.DESTINATION',
      value: "2",
      fields: [
        { label: 'ATA_CARNET.DEST_COUNTRY', value: 'India' },
        { label: 'ATA_CARNET.ENTRY_TYPE', value: 'Transit' },
        { label: 'ATA_CARNET.MODE_OF_TRANSPORT', value: 'By Air' },
        { label: 'ATA_CARNET.COUNTERFOLLIOS_REQUIRED', value: 2 }
      ]
    }
  ];

  // This method is used to initialize the class instance using router
  constructor(
    private router: Router
  ) {
    let storageData: any = localStorage.getItem('application-data');
    this.data = JSON.parse(storageData);
  }

  //Edit Product
  // This method is used to edit product using product
  editProduct(product: any) { }
  // Remove product
  // This method is used to remove product using product
  removeProduct(product: any) { }
  // This method is used to load page using e
  loadPage(e: any) { }
  // This method is used to back
  back() {
     let path = `/${RoutesPath.SERVICE}/ata-carnet`;
                        this.router.navigate([path])
  }
}
